var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: [
        "login-form-container",
        { "is-mobile": _setup.isMobileBreakpoint },
      ],
    },
    [
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c(
            "div",
            { staticClass: "login-container" },
            [
              _c("header", { staticClass: "title-container" }, [
                _c("p", {
                  staticClass: "text",
                  domProps: { innerHTML: _vm._s(_setup.text.intro) },
                }),
              ]),
              _c(_setup.FormComponent),
            ],
            1
          ),
          _c(_setup.HelpContainerComponent, { staticClass: "help-container" }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "img-degraded" },
        [
          _setup.isValid
            ? _c("img", {
                attrs: {
                  alt: "easter-egg",
                  src: require("@/assets/images/spinner.webp"),
                },
              })
            : [
                _c("img", {
                  staticClass: "vector",
                  attrs: {
                    src: require("@/assets/images/svg/form-vector.svg"),
                    alt: "Lefebvre vector",
                  },
                }),
                _c("img", {
                  staticClass: "image",
                  attrs: {
                    src: require("@/assets/images/woman-image.png"),
                    alt: "Lefebvre login",
                  },
                }),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }